import { Box, Button, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  PageBar,
  SSPCommonSingleFileSelector,
  SSPCommonTable,
  SSPCommonVideo,
} from "../../../CommonComponents";
import { Download } from "@mui/icons-material";
import AWS from "aws-sdk";
import { functionURLService } from "../../../Components/functionalurl";
import { post } from "../../../services";
import SSPCommonModal from "../../../CommonComponents/SSPCommonModal/SSPCommonModal";
import * as FileSaver from "file-saver";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import InventoryFileSelector from "../../../CommonComponents/InventoryFileSelector/InventoryFileSelector";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import {
  Divider,
  Grid,
  Link,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import InventoryButton from "../../../CommonComponents/InventoryButton/InventoryButton";
import Cookies from "js-cookie";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
const base = "https://";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};
const boxSX = {
  textDecoration: "none",
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
    color: "darkblue",
  },
};
// function to upload file into s3 bucket
const S3upload = async (folderpath, fileName, file) => {
  AWS.config.update({
    accessKeyId: "",
    secretAccessKey: "",
    region: "ap-south-1",
  });

  const s3 = new AWS.S3();
  const params = {
    Bucket: "more-ssp-prod",
    Key: folderpath + "/" + fileName,
    Body: file,
  };

  return new Promise((resolve, reject) => {
    s3.putObject(params, (err, data) => {
      if (err) {
        console.log(err);
        reject(err);
      } else {
        console.log("File uploaded successfully.");
        resolve(data);
      }
    });
  });
};

const InventoryBilling = () => {
  const id = Cookies.get("ssp_id");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const rowFetch = async () => {
    setmessage("Fetching Data");
    let response = await post(
      base +
      "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/upload_details",
      {
        user_id: parseInt(id),
        module: "module_name",
      },
      true,
      false
    );
    console.log("response", response);
    if (response.status === "success") {
      const rowsData = response?.body?.data?.map((row, index) => ({
        ...row,
        id: index + 1,
      }));
      // setOriginalRowsData(rowsData);
      setRows(rowsData);
    } else {
      // setmessage("No Rows");
      // setmodalOpener(true);
    }
  };
  useEffect(() => {
    rowFetch();
  }, []);
  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  const handlePdfFileSelect = (e) => {
    setSelectedPdfFile(e.target.files[0]);
  };


  const handleFileSelectButton = async () => {
    if (!selectedFile) {
      setmessage("Please select XLSX file.");
      setmodalOpener(true);
      return;
    }

    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    if (fileExtension !== "xlsx") {
      setmessage("Order details must be of excel format.");
      setmodalOpener(true);
      return;
    }

    if (selectedPdfFile) {
      const pdfFileExtension = selectedPdfFile.name
        .split(".")
        .pop()
        .toLowerCase();
      const specialCharsRegex = /[^A-Za-z0-9_ ().]/g;
      const pdfFileName = selectedPdfFile.name;

      if (
        pdfFileExtension !== "pdf" &&
        pdfFileExtension !== "eml" &&
        pdfFileExtension !== "zip"
      ) {
        setmessage(
          "Vendor document must be either in PDF, EML, or ZIP format."
        );
        setmodalOpener(true);
        return;
      }

      if (specialCharsRegex.test(pdfFileName)) {
        setmessage(
          "Only numbers, alphabets, underscore, and space are allowed in the file name."
        );
        setmodalOpener(true);
        return;
      }
    }

    const xlsxFileName = selectedFile.name;
    const specialCharsRegex = /[^A-Za-z0-9_ ().]/g;

    if (specialCharsRegex.test(xlsxFileName)) {
      setmessage(
        "Only numbers, alphabets, underscore, and space are allowed in the file name."
      );
      setmodalOpener(true);
      return;
    }
    const timestamp = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15); // YYYYMMDDTHHMMSS
    const folderName = "instiUploads";
    const pdffolderName = "instiUploads/vendor_documents";
    const filenameWithTimestamp = `${folderName}/${selectedFile.name
      .split(".")
      .slice(0, -1)
      .join(".")}_${timestamp}.${selectedFile.name.split(".").pop()}`;
    const fileNameNew = `${selectedFile.name
      .split(".")
      .slice(0, -1)
      .join(".")}_${timestamp}.${selectedFile.name.split(".").pop()}`;
    const pdfFilenameWithTimestamp = selectedPdfFile
      ? `${pdffolderName}/${selectedPdfFile.name
        .split(".")
        .slice(0, -1)
        .join(".")}_${timestamp}.${selectedPdfFile.name.split(".").pop()}`
      : null;

    const vendorDocPdfFilename = selectedPdfFile
      ? `${selectedPdfFile.name
        .split(".")
        .slice(0, -1)
        .join(".")}_${timestamp}.${selectedPdfFile.name.split(".").pop()}`
      : null;

    setSaveLoading(true);

    try {
      const xlsxPresignedUrlResponse = await post(
        base + "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/gen_pre_url",
        {
          filename: filenameWithTimestamp
        },
        true,
        false
      );
      const xlsxPresignedUrl = xlsxPresignedUrlResponse.data.response;
      if (!xlsxPresignedUrl) {
        throw new Error("Presigned URL for XLSX file is not valid");
      }

      // Upload the XLSX file using the presigned URL
      await uploadFileWithPresignedUrl(selectedFile, xlsxPresignedUrl);

      // If a PDF file is selected, fetch a presigned URL for it and upload
      if (selectedPdfFile) {
        const pdfPresignedUrlResponse = await post(
          base +
          "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/gen_pre_url",
          {
            filename: pdfFilenameWithTimestamp,
          },
          true,
          false
        );

        const pdfPresignedUrl = pdfPresignedUrlResponse.data.response;
        if (!pdfPresignedUrl) {
          throw new Error("Presigned URL for PDF file is not valid");
        }

        // Upload the PDF file using the presigned URL
        await uploadFileWithPresignedUrl(selectedPdfFile, pdfPresignedUrl);
      }

      await post(
        base +
        "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/save_data",
        {
          // file_name: selectedFile?.name,
          file_name: fileNameNew,
          // vendor_doc: selectedPdfFile ? selectedPdfFile.name : null,
          vendor_doc: vendorDocPdfFilename ? vendorDocPdfFilename : null,

          module_name: "insti_module",
          source: null,
        },
        true,
        false
      )
        .then((response) => {
          if (response?.status === "Success") {
            setmessage("File uploaded successfully");
            setmodalOpener(true);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            setmessage(response?.body?.message);
            setmodalOpener(true);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setmessage(error.toString());
          setmodalOpener(true);
        })
        .finally(() => {
          setSaveLoading(false);
        });
    } catch (error) {
      console.log(error);
      setmessage(error.toString());
      setmodalOpener(true);
      setSaveLoading(false);
    }
  };

  const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
    try {
      const fileUploadData = new FormData();
      Object.keys(generatedUrl.fields).forEach((key) => {
        fileUploadData.append(key, generatedUrl.fields[key]);
      });
      console.log("File to Upload:", filetoUpload);
      fileUploadData.append("file", filetoUpload);

      console.log("Uploading file to:", generatedUrl.url);
      console.log(fileUploadData, generatedUrl?.url);

      const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);

      if (fileUploaded) {
        return true;
      } else {
        console.error("File upload failed");
        return false;
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      throw error;
    }
  };

  const uploadFile = async (url, formData) => {
    try {
      const response = await axios.post(url, formData);

      if (response.status === 204) {
        console.log("File upload successful with status 204");
        return true;
      }

      if (response.status >= 200 && response.status < 300) {
        console.log("File upload successful");
        return true;
      } else {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      throw error;
    }
  };

  const ExcelJS = require("exceljs");
  const handleDownloadSampleFile = async () => {
    let response = await post(
      base +
      "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/download_template",
      {
        filename: "insti_inventory_billing_sample.xlsx",
      },
      true,
      false
    );
    window.open(response?.body?.data);
  };

  const handleDownloadCustomerMaster = async () => {
    let response = await post(
      base +
      "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/download_customer_master",
      {
        filename: "insti_inventory_billing_sample.xlsx",
      },
      true,
      false
    );
    window.open(response?.body?.data);
  };


  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };

  const CellWithModal = ({ approve_status, reason }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
      <div>
        <div
          className={clsx("status-text", { blue: reason })}
          style={statusStyle(approve_status)}
        >
          {approve_status}
        </div>
        {reason && (
          <div>
            <a
              href="#"
              onClick={handleOpen}
              style={{ color: "rgb(1,96,242)", fontWeight: "bold" }}
            >
              View Reason
            </a>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography
                  id="modal-modal-title"
                  variant="h5"
                  component="h2"
                  sx={{ fontWeight: "bold", margin: 2 }}
                >
                  Order Rejection Reason !
                </Typography>
                <Typography
                  id="modal-modal-description"
                  variant="h6"
                  component="h2"
                  sx={{
                    border: "1px solid grey",
                    height: 120,
                    textAlign: "left",
                    p: 1,
                  }}
                >
                  {reason}
                </Typography>
              </Box>
            </Modal>
          </div>
        )}
      </div>
    );
  };

  const cancelOrder = async (customer_order_no) => {
    if (loading) {
      return;
    }
    setLoading(true);

    try {
      let response = await post(
        base +
        "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/cancel_customer_order",
        {
          customer_order_no: parseInt(customer_order_no),
        },
        true,
        false
      );
      console.log("responsechellll", response);
      if (response?.status === "success") {
        // window.open(response?.body?.data);
        setmessage(response?.body?.message);
        setmodalOpener(true);
      }
      if (response?.status === "error") {
        setmessage(response?.body?.message);
        setmodalOpener(true);
        // window.open(response?.body?.data);
      }
      else {
        setmessage(response?.body?.message);
        setmodalOpener(true);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const columns = [
    { field: "id", headerName: "Sl.no", width: 70 },
    {
      field: "file_name",
      headerName: "Files Name",
      width: 160,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "created_at",
      headerName: "Date",
      width: 120,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 110,
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          positive: params.value === "Success",
          negative: params.value === "Error",
          partial: params.value === "Partial Success",
          processing: params.value === "Processing",
        });
      },
    },
    {
      field: "count",
      headerName: (
        <div style={{ fontSize: "14px", lineHeight: "1.2" }}>
          <div>No of records </div>
          <div>processed</div>
        </div>
      ),
      width: 130,
      align: "center",
    },
    {
      field: "current_status",
      headerName: "Process Log",
      width: 160,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          progressdata: params.value === "Customer Order Created",
          progressdatafail: params.value === "Customer Order Creation Failed",
          partial: params.value === "Invalid File/Data",
          processing: params.value === "Processing",
          negative: params.value === "Order Rejected",
        });
      },
    },
    {
      field: "progress_id",
      headerName: "Progress",
      width: 90,
      wrapText: true,
      align: "left",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          onClick={() => downloadProgressFile(params.row.log_id)}
        >
          <Download color="primary" />
        </IconButton>
      ),
    },
    {
      field: "documents_id",
      headerName: "Documents",
      width: 100,
      wrapText: true,
      align: "left",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          onClick={() => downloadDocuments(params.row.log_id)}
        >
          <Download color="primary" />
        </IconButton>
      ),
    },
    {
      field: "customer_name",
      headerName: "Customer Name",
      width: 170,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "customer_order_no",
      headerName: (
        <div style={{ fontSize: "14px", lineHeight: "1.2" }}>
          <div>Customer</div>
          <div>Order No</div>
        </div>
      ),
      width: 90,
      wrapText: true,
      align: "center",
    },

    {
      field: "draft_invoice",
      headerName: "Draft Invoice",
      type: "number",
      width: 120,
      align: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          disabled={params.row.status !== "Success"}
          onClick={() =>
            downloadDraftInvoiceFile(
              params.row.log_id,
              params.row.customer_order_no
            )
          }
        >
          <Download
            color={params.row.status !== "Success" ? "grey" : "primary"}
          />
        </IconButton>
      ),
    },
    {
      field: "final_invoice",
      headerName: "Final Invoice",
      type: "number",
      width: 120,
      align: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          disabled={loading || params.row.status !== "Success"}
          onClick={() =>
            downloadFinalInvoiceFile(
              params.row.log_id,
              params.row.customer_order_no
            )
          }
        >
          <Download
            color={params.row.status !== "Success" ? "grey" : "primary"}
          />
        </IconButton>
      ),
    },
    {
      field: "Cancel_order",
      headerName: "Cancel Order",
      type: "number",
      width: 120,
      align: "center",
      renderCell: (params) => (
        <div>
          <Button
            size="small"
            style={{ backgroundColor: '#e81500', color: 'white', width: '100px', opacity: params.row.status != "Success" || params.row.current_status == "Processing" ? 0.5 : 1, }}
            onClick={() => cancelOrder(params.row.customer_order_no)}
            disabled={loading || params.row.status != "Success" || params.row.current_status == "Processing"}
          >
            {"Cancel"}
          </Button>

        </div>
      ),
    },
  ];

  function statusStyle(approve_status) {
    switch (approve_status) {
      case "Created":
        return { color: "rgb(4,171,105)", fontWeight: "600" }; // Set the color for "Created" status
      case "Rejected":
        return { color: "rgb(234,39,21)", fontWeight: "600" }; // Set the color for "Rejected" status
      case "Invalid File/Data":
        return { color: "rgb(244,161,0)", fontWeight: "600" }; // Set the color for "Invalid File/Data" status
      case "Pending":
        return { color: "rgb(3,95,240)", fontWeight: "600" }; // Set the color for "Pending" status
      default:
        return {};
    }
  }

  // to download Progress file from table
  const downloadProgressFile = async (id) => {
    let response = await post(
      base +
      "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/process_log",
      JSON.stringify({ log_id: id }),
      true,
      false
    );
    console.log("Download log testing==", response)

    if (response.status === "success") {
      window.open(response?.body?.data || response?.data);
    } else {
      setmessage(response.body?.message);
      setmodalOpener(true);
    }
    // let data1 = response?.data.map((obj) => ({
    //   customer_account_number: obj.customer_account_number,
    //   bill_to: obj.bill_to,
    //   location_code: obj.location_code,
    //   item: obj.item,
    //   cost: obj.cost,
    //   mrp: obj.mrp,
    //   promo: obj.promo,
    //   additional_vendor_support: obj.additional_vendor_support,
    //   off_invoice_margin: obj.off_invoice_margin,
    //   discount: obj.discount,
    //   billing_price: obj.billing_price,
    //   order_qty: obj.order_qty,
    //   supplier: obj.supplier,
    //   log_id: obj.log_id,
    //   created_at: obj.created_at,
    //   validation_error: obj.validation_error,
    // }));
    // DownloadExcelSheet(data1, "inventory_billing");


  };

  const downloadDocuments = async (log_id) => {
    try {
      let response = await post(
        base +
        "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/documents_data",
        {
          log_id: parseInt(log_id),
        },
        true,
        false
      );
      if (response.status === "success") {
        window.open(response.body.data);
      } else {
        setmessage(response.body?.message);
        setmodalOpener(true);
      }
    } catch (error) {
      // Handle error if any
      console.error(error);
    }
  };

  // to download Draft Invoice
  const downloadDraftInvoiceFile = async (log_id, customer_order_no) => {
    let response = await post(
      base +
      "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/draft_invoice",
      {
        user_id: parseInt(id),
        log_id: parseInt(log_id),
        customer_order_no: parseInt(customer_order_no),
      },
      true,
      false
    );
    window.open(response.body.draft_invoice_url);
  };

  const downloadFinalInvoiceFile = async (log_id, customer_order_no) => {
    if (loading) {
      return; // Ignore the click if already loading
    }
    setLoading(true); // Start loading

    try {
      let response = await post(
        base +
        "7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws/final_invoice",
        {
          user_id: parseInt(id),
          log_id: parseInt(log_id),
          customer_order_no: parseInt(customer_order_no),
        },
        true,
        false
      );
      if (response?.status === "success") {
        window.open(response?.body.final_invoice_url);
      } else {
        setmessage(response?.body?.message);
        setmodalOpener(true);
      }
    } catch (error) {
      // Handle error if any
      console.error(error);
    }
    setLoading(false); // Stop loading
  };

  const DownloadExcelSheet = async (response, fileName) => {
    if (response !== null) {
      let data = response;
      data[0]["date"] = Date();
      const workbook = new ExcelJS.Workbook();
      const headers = Object.keys(data[0]);
      const worksheet = workbook.addWorksheet("data");
      const firstRow = worksheet.getRow(1);
      for (let i = 1; i <= headers.length; i++) {
        const cell = firstRow.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFA500" },
        };
      }
      worksheet.columns = headers.map((header) => ({ header, key: header }));
      data.forEach((dataRow) => {
        worksheet.addRow(dataRow);
      });
      worksheet.columns.forEach((column) => {
        column.width = 25;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
      });
    } else {
      setmessage("No data provided to download the file");
      setmodalOpener(true);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EEF2F7",
      }}
    >
      {/* Page Bar */}
      <PageBar text={"Insti Billing : Inventory Billing"} />
      <Card
        sx={{
          backgroundColor: "#EEF2F7",
          padding: "1.3rem",
        }}
      >
        <CardHeader
          p={2}
          sx={{
            backgroundColor: "#F8F8F9",
            fontWeight: "700",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          }}
          title={"Order Upload "}
          titleTypographyProps={{
            sx: {
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "16px",
              color: "#0160F1",
            },
          }}
        />
        <Divider />
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
            fontSize: 15,
            // marginBottom: -5
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Grid container rowSpacing={1}>
              <Grid item xs={5} sx={{ backgroundColor: "white" }}>
                <Typography>
                  <b style={{ color: "red" }}>&nbsp;&nbsp;&nbsp;*&nbsp;</b>
                  Upload your order details
                </Typography>
                <Box
                  p={2}
                  sx={{
                    display: { lg: "flex", md: "flex" },
                    gap: "1rem",
                  }}
                >
                  {/* Choose File  */}
                  <Box
                    p={1}
                    sx={{
                      border: "1px solid lightgrey",
                      borderRadius: "5px",
                      marginBottom: { sm: "1rem" },
                    }}
                  >
                    <input
                      type="file"
                      // accept=".xlsx"
                      multiple={false}
                      onChange={handleFileSelect}
                    />
                  </Box>
                </Box>
              </Grid>
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  marginRight: 5,
                  marginLeft: 5,
                  backgroundColor: "#c0c0c0",
                  width: 2,
                }}
              />

              <Grid item xs={6}>
                <Typography>
                  <b style={{ color: "red" }}></b>Upload Vendor Document
                  (PDF/EML/ZIP file only)
                </Typography>

                <Box
                  p={2}
                  sx={{
                    display: { lg: "flex", md: "flex" },
                    gap: "1rem",
                  }}
                >
                  <Box
                    p={1}
                    sx={{
                      border: "1px solid lightgrey",
                      borderRadius: "5px",
                      marginBottom: { sm: "1rem" },
                    }}
                  >
                    <input
                      type="file"
                      // accept=".zip"
                      multiple={false}
                      onChange={handlePdfFileSelect}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Button to save data  */}
            <Grid container rowSpacing={1}>
              {/* Link text  */}

              <Box
                p={1}
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "16px",
                  marginLeft: "1rem",
                }}
              >
                <Link
                  component={"button"}
                  color={"#0160F1"}
                  sx={boxSX}
                  onClick={() => {
                    handleDownloadSampleFile();
                  }}
                >
                  Download Sample File
                </Link>
              </Box>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  height: "1.2rem",
                  marginTop: 1,
                  backgroundColor: "#c0c0c0",
                  width: 2,
                }}
              />
              <Box
                p={1}
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "16px",
                  marginLeft: "1rem",
                }}
              >
                <Link
                  component={"button"}
                  color={"#0160F1"}
                  sx={boxSX}
                  onClick={() => {
                    handleDownloadCustomerMaster();
                  }}
                >
                  Download Customer Master
                </Link>
              </Box>
            </Grid>
            <Grid item xs={9}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <InventoryButton
                  btnText={"SAVE DATA"}
                  btnFunction={handleFileSelectButton}
                  loading={saveLoading}
                />
              </Box>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      {/* Table  */}
      {/* <SSPCommonTable
        headerTitle={"Upload Files Status"}
        columnTable={columns}
        functional_url="7xinugyudasd7a2zjctyqpewcu0tqnpo.lambda-url.ap-south-1.on.aws"
        table_data_function_name="/upload_details"
        download_file_name="inventory_billing_download"
        row_data_function_name="/process_log"
        module_name="insti_module"
        user_id={id}
      /> */}

      <Card
        sx={{
          backgroundColor: "#EEF2F7",
          padding: "1.3rem",
        }}
      >
        <CardHeader
          p={2}
          sx={{
            backgroundColor: "#F8F8F9",
            fontWeight: "700",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          }}
          title={"Uploaded Files"}
          titleTypographyProps={{
            sx: {
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "16px",
              color: "#0160F1",
            },
          }}
          action={
            <>
              <Button onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
            </>
          }
        />
        <Divider />
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
          }}
        >
          <Box
            sx={{
              height: 700,
              width: "100%",
              "& .super-app.positive": {
                color: "rgb(4,171,105)",

                fontWeight: "600",
              },
              "& .super-app.negative": {
                color: "rgb(234,39,21)",

                fontWeight: "600",
              },
              "& .super-app.partial": {
                color: "rgb(244,161,0)",

                fontWeight: "600",
              },
              "& .super-app.progressdata": {
                color: "rgb(4,171,105)",

                fontWeight: "600",
              },
              "& .super-app.progressdatafail": {
                color: "rgb(234,39,21)",

                fontWeight: "600",
              },
              "& .super-app.progressdatapartial": {
                color: "rgb(244,161,0)",

                fontWeight: "600",
              },
              "& .super-app.processing": {
                color: "rgb(104,112,122)",

                fontWeight: "600",
              },
              "& .super-app.pending": {
                color: "rgb(3,95,240)",

                fontWeight: "600",
              },
            }}
          >
            <DataGrid
              // disableColumnMenu={true}
              rowHeight={80}
              showCellRightBorder={true}
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold !important",
                },
                overflowX: "scroll",
              }}
              rows={rows}
              columns={columns}
              headerClassName="header-center"
              rowsPerPageOptions={[10]}
              pageSize={10}
              getRowId={(row) => row.id}
              components={{
                Toolbar: GridToolbar,
              }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>
      <SSPCommonVideo
        headerText={"Demo Video"}
        videoUrl={
          "https://www.youtube.com/embed/Y_AcHLummLY?si=RUbPLu-cip0CphpN"
        }
      />
      {modalOpener && (
        <SSPCommonModal
          open={modalOpener}
          handleOpenClose={setmodalOpener}
          message={message}
        />
      )}
    </Box>
  );
};

export default InventoryBilling;
